<template>
  <gmap-info-window
    :options="{
      pixelOffset: {
        width: 0,
        height: -35,
      },
    }"
    :position="infoPosition"
    :opened="infoOpened"
    @closeclick="closeClick()"
  >
    <div class="info-wrapper">
      <div class="pin-details">
        <div class="info-hd">
          <router-link
            v-if="eventStartDate"
            :to="`/upcoming-events/${locationSlug}`"
            >{{ locationName }}</router-link
          >
          <div v-else-if="location.slug == undefined">
            {{ locationName }}, AL
          </div>
          <router-link v-else :to="`/places-to-go/${locationSlug}`">{{
            locationName
          }}</router-link>
        </div>
        <div v-if="location.type" class="location-type">
          {{ location.type.replace(/([A-Z])/g, ' $1').trim() }}
        </div>
        <div v-else-if="location._type" class="location-type">
          {{ location._type.replace(/([A-Z])/g, ' $1').trim() }}
        </div>
        <div v-if="location.slug !== undefined" class="info-address">
          <a
            :href="`https://www.google.com/maps/dir/${encodeURI(
              locationName
            )},${encodeURI(
              locationAddress + ' ' + locationCity + ', AL ' + locationZip
            )}`"
          >
            <span
              >{{ locationAddress || location.address1 }}<br />
              {{ locationCity }}, AL {{ locationZip }}</span
            >
          </a>
        </div>
      </div>
      <div v-if="location.slug !== undefined" class="fav-heart">
        <UserFavorite
          parent="map"
          :objectid="location.id"
          :slug="location.slug"
          :notSignedInMap="true"
          :signInWithNoTripsMap="true"
          :signInWithTripsMap="true"
        />
      </div>
    </div>
  </gmap-info-window>
</template>

<script>
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import UserFavorite from '@/components/Common/UserFavorite.vue';

@Component({
  components: {
    UserFavorite,
  },
})
class MapInfoWindow extends Vue {
  @Watch('location', { immediate: true, deep: false })
  onLocationChange() {
    this.changeLocation();
  }

  @Prop({
    type: Object,
  })
  location;

  infoOpened = false;

  infoPosition = { lat: 10, lng: 10 };

  locationName = '';

  locationType = '';

  locationAddress = '';

  locationCity = '';

  locationZip = '';

  locationSlug = '';

  eventStartDate = '';

  async closeClick() {
    await this.$store.dispatch('maps/resetSelectedLocation');
    this.infoOpened = false;
  }

  changeLocation() {
    if (!this.location) {
      this.infoOpened = false;
    } else {
      this.infoOpened = true;
      this.infoPosition = this.location.position;
      this.locationName = this.location.name;
      this.locationType = this.location.type;
      this.locationAddress = this.location.address;
      this.locationCity = this.location.city;
      this.locationZip = this.location.zip;
      this.locationSlug = this.location.slug;
      this.eventStartDate = this.location.eventStartDate;
    }
  }
}
export default MapInfoWindow;
</script>

<style scoped>
.info-wrapper a {
  color: #173945 !important;
}
.info-hd a {
  text-decoration: underline;
}
.info-wrapper {
  display: grid;
  gap: 0px;
  grid-template-areas: 'fav-heart pin-details';
  margin-bottom: 10px;
  padding: 5px 15px 5px 5px;
  color: #173945 !important;
}
.location-type {
  color: #6c767f;
  font-family: 'IdealSans-Book';
  font-size: 12px;
  text-align: left;
  padding-bottom: 5px;
}
.info-hd {
  font-family: 'klinicslabbold';
  font-size: 18px;
  text-align: left;
}
.info-address {
  font-family: 'IdealSans-Book';
  font-size: 12px;
  text-align: left;
}
.gm-style-iw-c {
  border-radius: 0px !important;
}
.fav-heart {
  grid-area: 'fav-heart';
  margin-right: 39px;
  position: relative;
  right: 10px;
  bottom: 12px;
}
.pin-details {
  grid-area: 'pin-details';
  margin-right: 8px;
}
</style>
